/** Design System Spacings */
export const DS_SPACINGS = {
  xxs: '4px',
  xs: '8px',
  s: '12px',
  componentOnly: '10px',
  base: '16px',
  m: '24px',
  l: '32px',
  xl: '48px',
  xxl: '64px',
  xxxl: '128px',
} as const;
